import React, { Component } from 'react';
import {
  FavoriteSelectedIcon,
  FavoriteIcon,
  Toast,
} from '@paypalcorp/pp-react';
import styles from './SetPreferredHeart.less';
import * as analytics from '../../lib/analytics';

export default class SetPreferredHeart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showToastPreferredMessage: this.props.showToastPreferredMessage,
      isPreferredCharitySwitch: this.props.isPreferredCharitySwitch,
    };
  }

  getToastPreferredMessage() {
    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );
    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );

    if (this.props.hasError) {
      analytics.instance.recordEvent(
        analytics.events.DW_GIVING_FAVORITE_ERROR_OCCURRED,
        {
          e: 'ac',
          product: 'dw_giving',
          account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
          acct_cntry: contentCountry,
          charityName: this.props.charityName || '',
          crid: this.props.nonprofitId,
          flow: 'set_favorite_charity',
        }
      );
      return this.props.errorMessage;
    }

    if (!this.props.selected) {
      return this.props
        .i18n('toast.no-longer-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }

    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_FAVORITE_SUCCESS_SCREEN_SHOWN,
      {
        e: 'im',
        product: 'dw_giving',
        account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
        acct_cntry: contentCountry,
        charityName: this.props.charityName || '',
        crid: this.props.nonprofitId,
        flow: 'set_favorite_charity',
      }
    );

    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_FAVORITE_SUCCESS_OCCURRED,
      {
        e: 'ac',
        product: 'dw_giving',
        account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
        acct_cntry: contentCountry,
        charityName: this.props.charityName || '',
        crid: this.props.nonprofitId,
        flow: 'set_favorite_charity',
      }
    );

    if (this.props.selected && this.state.isPreferredCharitySwitch) {
      return this.props
        .i18n('toast.new-preferred-charity')
        .replace('{charityName}', this.props.charityName);
    }
    return this.props.i18n('toast.preferred-charity');
  }

  componentWillUnmount() {
    this.setState({
      showToastPreferredMessage: false,
      isPreferredCharitySwitch: false,
    });
  }

  renderHeartIcon() {
    return this.props.selected ? (
      <FavoriteSelectedIcon
        alt={this.props.i18n('label.preferred-charity')}
        role='link'
        aria-label={this.props.i18n('label.preferred-charity')}
        className={styles['heart-filled']}
        name='favorite-selected'
        data-nemo='npo-heart-filled'
        size='sm'
        as='svg'
      />
    ) : (
      <FavoriteIcon
        alt={this.props.i18n('label.set-preferred')}
        role='link'
        aria-label={this.props.i18n('label.set-preferred')}
        className={styles['heart-empty']}
        name='favorite'
        size='sm'
        as='svg'
      />
    );
  }

  render() {
    return (
      <>
        {this.state.showToastPreferredMessage && (
          <Toast
            key='toast_success'
            id='toast_success'
            message={this.getToastPreferredMessage()}
            isSuccess={this.props.selected && !this.props.hasError}
            theme='v2'
          />
        )}
        {this.renderHeartIcon()}
      </>
    );
  }
}
